import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.053 1.117a3.813 3.813 0 0 1 5.393 0l5.437 5.437a3.813 3.813 0 0 1 0 5.393L18.96 16.87a6.376 6.376 0 0 1-1.42 6.857l-.906.907a1.25 1.25 0 0 1-1.768 0L8.5 18.268l-4.1 4.1A1.25 1.25 0 0 1 2.632 20.6l4.1-4.1-6.366-6.366a1.25 1.25 0 0 1 0-1.767l.906-.907A6.377 6.377 0 0 1 8.13 6.04l4.923-4.923Zm2.697 20.865.022-.022a3.879 3.879 0 0 0 .6-4.71 1.25 1.25 0 0 1 .192-1.52l5.551-5.551a1.313 1.313 0 0 0 0-1.857l-5.437-5.438a1.313 1.313 0 0 0-1.857 0L9.269 8.436a1.25 1.25 0 0 1-1.52.192 3.878 3.878 0 0 0-4.709.6l-.022.022L15.75 21.982Z",
      fill: "#394053"
    }, null, -1)
  ]))]))
}
export default { render: render }